export default __webpack_public_path__ + "static/media/Montserrat.3068cdb4.ttf";